import React, { useEffect } from "react";
import { Send, Mail, MapPin, Clock } from "lucide-react";
import { useSettings } from "../context/SettingsContext";

export default function ContactPage() {
  const { settings } = useSettings();
  useEffect(() => {
    document.title = "Contact Aducation — Telegram, Email Support | India's Ed-Tech";
  }, []);

  return (
    <div data-testid="contact-page">
      <section className="relative overflow-hidden">
        <div className="hero-glow absolute inset-0 pointer-events-none" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-14 pb-16 relative">
          <div className="text-xs uppercase tracking-[0.3em] text-amber-400 font-semibold mb-3">Get In Touch</div>
          <h1 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tighter">
            Let's <span className="gold-text">Talk</span>.
          </h1>
          <p className="mt-4 text-slate-400 max-w-2xl text-lg">
            Questions about courses, batches or your dream career? Reach out — we usually reply within 2 hours.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-24">
        <div className="grid md:grid-cols-2 gap-6">
          <a
            data-testid="contact-telegram-card"
            href={`https://t.me/${settings.telegram_username}`}
            target="_blank"
            rel="noreferrer"
            className="glass rounded-3xl p-8 lg:p-10 hover:border-amber-400/50 transition group relative overflow-hidden"
          >
            <div className="absolute -top-16 -right-16 w-48 h-48 rounded-full bg-amber-500/10 blur-3xl group-hover:bg-amber-500/25 transition duration-700" />
            <div className="relative">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-gradient-to-br from-[#F59E0B] to-[#D97706] btn-gold-glow mb-6">
                <Send size={28} className="text-white" />
              </div>
              <div className="text-xs uppercase tracking-widest font-bold text-amber-400 mb-2">Fastest Response</div>
              <h3 className="font-display font-bold text-2xl text-white mb-3">Chat on Telegram</h3>
              <p className="text-slate-400 mb-5">
                Join our Telegram channel for instant support, batch updates, and exclusive tips.
              </p>
              <div className="inline-flex items-center gap-2 text-amber-300 font-semibold group-hover:translate-x-1 transition">
                @{settings.telegram_username} →
              </div>
            </div>
          </a>

          <a
            data-testid="contact-email-card"
            href={`mailto:${settings.support_email}`}
            className="glass rounded-3xl p-8 lg:p-10 hover:border-red-400/50 transition group relative overflow-hidden"
          >
            <div className="absolute -top-16 -right-16 w-48 h-48 rounded-full bg-red-500/10 blur-3xl group-hover:bg-red-500/25 transition duration-700" />
            <div className="relative">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-gradient-to-br from-[#E50914] to-[#B91C1C] btn-red-glow mb-6">
                <Mail size={28} className="text-white" />
              </div>
              <div className="text-xs uppercase tracking-widest font-bold text-red-400 mb-2">Support Email</div>
              <h3 className="font-display font-bold text-2xl text-white mb-3">Write to Us</h3>
              <p className="text-slate-400 mb-5">
                For business enquiries, partnership, or detailed course queries — drop us an email.
              </p>
              <div className="inline-flex items-center gap-2 text-red-300 font-semibold group-hover:translate-x-1 transition">
                {settings.support_email} →
              </div>
            </div>
          </a>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mt-6">
          <div className="glass rounded-2xl p-6 flex items-start gap-4">
            <MapPin size={24} className="text-amber-400 shrink-0 mt-0.5" />
            <div>
              <div className="text-xs uppercase tracking-widest font-bold text-slate-400 mb-1">Based In</div>
              <div className="text-white font-semibold">India · Remote First</div>
              <div className="text-sm text-slate-400 mt-1">Serving learners across 28 states & 8 UTs</div>
            </div>
          </div>
          <div className="glass rounded-2xl p-6 flex items-start gap-4">
            <Clock size={24} className="text-red-400 shrink-0 mt-0.5" />
            <div>
              <div className="text-xs uppercase tracking-widest font-bold text-slate-400 mb-1">Support Hours</div>
              <div className="text-white font-semibold">Mon – Sun · 9:00 AM to 9:00 PM IST</div>
              <div className="text-sm text-slate-400 mt-1">Telegram: 24×7 auto-replies</div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
